import { useState } from 'react';

import { Link } from '@suntex.core/nav';
import { Button, Modal } from '@suntex.fim/ui';
import { InfoCircleLg } from '@suntex.fim/ui/icons';

export function RankingsInfo() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <span>
        <Button
          aria-label="FIM Rankings information"
          intent="icon"
          icon={<InfoCircleLg />}
          onClick={() => setIsModalOpen(true)}
        />
      </span>
      <Modal
        closable={false}
        centered
        title="FIM Rankings"
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        width={900}
        className="current-ranking-info"
        footer={[
          <Button
            key="submit"
            intent="tertiary"
            onClick={() => setIsModalOpen(false)}
          >
            Okay
          </Button>,
        ]}
      >
        <p className="fw-bold">
          Use First In Math Rankings as a motivational tool
        </p>
        <ul>
          <li>
            Rankings can be viewed by any logged-in Player for those
            concentrated on &apos;bragging rights&apos; in a particular
            category.
          </li>
          <li>
            Conduct your own classroom, school, or district competition and
            build a contest around the Rankings! (Pro Tip: Letters,
            certificates, awards, plaques or trophies are a great way to
            formally recognize year-long effort from top-level players, teams,
            schools, districts, family members and educators.)
          </li>
          <li>
            We will be glad to help promote your winners, events and any related
            efforts on our social media channels.
          </li>
        </ul>
        <p style={{ marginTop: '20px', marginLeft: '10px' }}>
          If your school is not focused on public rewards or recognition, our{' '}
          <Link
            to="https://explore.firstinmath.com/automatic-awards-and-achievement?cc=us"
            target="_blank"
          >
            Automatic Awards System
          </Link>{' '}
          is still on duty 24/7 to encourage students and spur academic
          achievement in much the same way as the Rankings do.
        </p>
        <p style={{ marginTop: '20px' }} />
        <p>
          <span className="fw-bold">Top 100 Schools:</span> Only Schools with
          100 or more active players are eligible to appear.
        </p>
        <p>
          <span className="fw-bold">All Teams:</span> Only teams with 10 or more
          players are eligible to appear.
        </p>
        <p className="text-sm text-chalkboard-txt">
          *All categories are currently updated in real-time.
        </p>
      </Modal>
    </>
  );
}
